/* Titres courts sur les cartes produit Horizon et dans le panier.
   Les titres Shopify sont longs pour Google (mots-clés) ; sur le site on
   n'affiche que le nom de la pièce, avant le premier tiret long. Le titre
   complet reste dans l'attribut title du lien. Dans le panier, le détail
   passe sur une seconde ligne discrète.
   Fiche technique : dans les descriptions, chaque valeur commence par un
   tiret long ; présentées en cartes, elles n'en ont plus besoin. Seul
   l'affichage change, le texte envoyé à Google reste celui de Shopify. */
(function () {
  var DASH = /^\s*[—–]\s*/;
  var PIECE = /^(Bague|Collier|Bracelet|Boucles|Pendentif|Jonc|Ring|Kette|Armband|Necklace)/;
  function court(t) { var i = t.indexOf(' — '); return i > 0 ? t.slice(0, i) : t; }
  function appliquer() {
    document.querySelectorAll('product-card .text-block p, product-card .product-grid-view-zoom-out--details h3').forEach(function (el) {
      if (el.getAttribute('data-co-court')) return;
      var t = el.textContent.trim();
      var c = court(t);
      if (c !== t && PIECE.test(t)) {
        var a = el.closest('a');
        if (a && !a.getAttribute('title')) a.setAttribute('title', t);
        el.textContent = c;
      }
      el.setAttribute('data-co-court', '1');
    });
    document.querySelectorAll('.cart-items__title').forEach(function (el) {
      if (el.querySelector('.co-cart-detail')) return;
      var t = el.textContent.trim();
      var i = t.indexOf(' — ');
      if (i <= 0 || !PIECE.test(t)) return;
      el.setAttribute('title', t);
      el.textContent = t.slice(0, i);
      var d = document.createElement('span');
      d.className = 'co-cart-detail';
      d.style.cssText = 'display:block;margin-top:2px;font-size:12px;line-height:1.4;color:var(--co-ink-mute,#6B6B6B)';
      d.textContent = t.slice(i + 3);
      el.appendChild(d);
    });
    document.querySelectorAll('.product-details ul:not(.co-preuve) li').forEach(function (li) {
      if (li.getAttribute('data-co-spec')) return;
      li.setAttribute('data-co-spec', '1');
      for (var n = li.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && DASH.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(DASH, ''); break; }
      }
    });
  }
  var attente = 0;
  new MutationObserver(function () { if (attente) return; attente = requestAnimationFrame(function () { attente = 0; appliquer(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') appliquer(); else document.addEventListener('DOMContentLoaded', appliquer);
})();